<script setup lang="ts">
/** On/off switch: clearer than a checkbox or a "Yes/No" pill. */
defineProps<{ modelValue: boolean; label: string; disabled?: boolean }>();
const emit = defineEmits<{ 'update:modelValue': [v: boolean] }>();
</script>

<template>
  <button
    type="button"
    role="switch"
    class="toggle"
    :class="{ on: modelValue }"
    :aria-checked="modelValue"
    :aria-label="label"
    :title="label"
    :disabled="disabled"
    @click="emit('update:modelValue', !modelValue)"
  >
    <span class="knob"></span>
  </button>
</template>

<style scoped>
.toggle {
  position: relative;
  width: 36px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: var(--border-strong);
  cursor: pointer;
  flex: none;
  transition: background 0.15s ease;
}
.toggle.on {
  background: var(--accent);
}
.toggle:disabled {
  opacity: 0.45;
  cursor: default;
}
.knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.25);
  transition: transform 0.15s ease;
}
.on .knob {
  transform: translateX(16px);
}
@media (prefers-reduced-motion: reduce) {
  .toggle,
  .knob {
    transition: none;
  }
}
</style>
